<template>
  <a-modal
    v-model:visible="visible"
    :width="1012"
    title="优秀案例详情"
    :footer="null"
    :maskClosable="false"
    wrapClassName="caseDetailModal"
  >
    <div class="detailContent">
      <a-skeleton active :loading="detailLoading">
        <div class="formDetail">
          <div
            v-for="(item, index) in detailConfig"
            :class="['detailItem', item.class]"
            :key="index"
          >
            <span class="itemLabel">{{ item.label }}：</span>
            <span class="itemValue" v-if="item.formart">
              {{ item.formart(caseDetailInfo) }}
            </span>
            <span class="itemValue" v-else>{{ caseDetailInfo[item.value] || '--' }}</span>
          </div>
        </div>
        <div class="editTemplate">
          <div style="text-align: right" v-if="canEdit">
            <a-button v-if="mode === 'preview'" @click="mode = 'edit'" type="primary">
              编辑
            </a-button>
            <a-button v-if="mode === 'edit'" style="margin-right: 8px" @click="mode = 'preview'">
              取消
            </a-button>
            <a-button v-if="mode === 'edit'" type="primary" @click="saveCaseDetail">保存</a-button>
          </div>
          <div v-for="(item, index) in templateConfig" :key="index">
            <div class="title">{{ item.title }}</div>
            <div class="content">
              <span v-if="mode === 'preview'">
                {{ caseDetailInfo[item.value] || '--' }}
              </span>
              <a-textarea
                v-else
                class="caseTextArea"
                v-model:value="caseDetailInfo[item.value]"
                showCount
                :maxlength="500"
              />
            </div>
          </div>
        </div>
      </a-skeleton>
    </div>
  </a-modal>
</template>

<script setup>
import { defineExpose, ref, defineProps } from 'vue'
import { ExcellentCaseDetail, ExcellentCaseUpdate } from '@/api/ExcellentCase/index'
import { message } from 'ant-design-vue'

defineProps({
  canEdit: {
    type: Boolean,
    default: true
  }
})

const visible = ref(false)
const mode = ref('preview')
const curExcellentCaseId = ref('')
const detailLoading = ref(true)
const showCaseDetail = ctx => {
  detailLoading.value = true
  curExcellentCaseId.value = ctx.excellentCaseId
  visible.value = true
  getDetailInfo()
}

const caseDetailInfo = ref({})
const getDetailInfo = () => {
  ExcellentCaseDetail({
    excellentCaseId: curExcellentCaseId.value
  }).then(res => {
    caseDetailInfo.value = res
    detailLoading.value = false
  })
}

const bdInfoMerge = record => {
  const { dptName, branchCompanyName, majorAreaName } = record
  return dptName + ' ' + branchCompanyName + ' ' + majorAreaName
}

const detailConfig = [
  { label: '工单ID', value: 'workOrderId', class: ['sLabel'] },
  { label: '工单类型', value: 'workOrderTypeName', class: ['mLabel', 'noBorder'] },
  { label: '健管', value: 'daName', class: ['sLabel'] },
  { label: '医生', value: 'doctorName', class: ['sLabel'] },
  { label: '患者', value: 'patientName', class: ['sLabel', 'noBorder'] },
  { label: 'BD', value: 'bdName', class: ['sLabel'] },
  {
    label: '部门',
    value: '',
    class: ['mLabel', 'noBorder'],
    formart: record => bdInfoMerge(record)
  }
]

const templateConfig = [
  { title: '背景', value: 'caseBackground' },
  { title: '内容', value: 'caseContent' },
  { title: '结果', value: 'caseResult' },
  { title: '价值', value: 'caseValue' }
]

const saveCaseDetail = () => {
  const { excellentCaseId, caseBackground, caseContent, caseResult, caseValue } =
    caseDetailInfo.value
  ExcellentCaseUpdate({
    excellentCaseId,
    caseBackground,
    caseContent,
    caseResult,
    caseValue
  }).then(res => {
    message.success('保存成功！')
    mode.value = 'preview'
    getDetailInfo()
  })
}

defineExpose({
  showCaseDetail
})
</script>

<style lang="scss" scoped>
.detailContent {
  height: 680px;
  overflow-y: scroll;
  padding: 0 24px;

  .formDetail {
    display: flex;
    flex-wrap: wrap;

    .detailItem {
      border-bottom: 1px solid #e8e8e8;
      line-height: 44px;
      font-size: 14px;
      position: relative;
      padding: 7.5px 0;
      .itemLabel {
        color: #999999;
      }
      .itemValue {
        color: #333333;
        font-weight: 500;
      }
    }

    .detailItem::after {
      content: '';
      width: 1px;
      border-right: 1px solid #e8e8e8;
      height: 30px;
      background: red;
      position: absolute;
      right: 12px;
      top: 14.5px;
    }

    .noBorder::after {
      display: none;
    }

    .sLabel {
      width: 33.3%;
    }
    .mLabel {
      width: 66.6%;
    }
    .lLabel {
      width: 100%;
      background: #fafafa;
    }
  }

  .editTemplate {
    margin-top: 16.5px;
    background-color: #fafafa;
    overflow: hidden;
    min-height: 476px;
    padding: 16px 20px;
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #000000d9;
      margin-bottom: 6px;
    }

    .content {
      font-weight: 500;
      font-size: 14px;
      color: #595959;
      margin-bottom: 16px;
    }
  }
}
</style>

<style lang="scss">
.caseDetailModal {
  .ant-modal .ant-modal-body {
    padding: 13px 0px;
    background: #fff;
  }

  .caseTextArea {
    .ant-input {
      min-height: 130px;
      background: #fafafa;
    }
  }
}
</style>
